module.exports = __webpack_public_path__ + "static/img/db2a58c.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/bdyxgg/wechat.png
// module id = 632
// module chunks = 2